module.exports = __webpack_public_path__ + "static/media/life.88e391e9.webp";